import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Sortable Table of Search Queries", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("table", {
  id: "keywords",
  cellspacing: "0",
  cellpadding: "0"
}, [
  /*#__PURE__*/_createElementVNode("thead", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("span", null, "Keywords")
      ]),
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("span", null, "Impressions")
      ]),
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("span", null, "Clicks")
      ]),
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("span", null, "CTR")
      ]),
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("span", null, "Rank")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", { class: "lalign" }, "silly tshirts"),
      /*#__PURE__*/_createElementVNode("td", null, "6,000"),
      /*#__PURE__*/_createElementVNode("td", null, "110"),
      /*#__PURE__*/_createElementVNode("td", null, "1.8%"),
      /*#__PURE__*/_createElementVNode("td", null, "22.2")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", { class: "lalign" }, "desktop workspace photos"),
      /*#__PURE__*/_createElementVNode("td", null, "2,200"),
      /*#__PURE__*/_createElementVNode("td", null, "500"),
      /*#__PURE__*/_createElementVNode("td", null, "22%"),
      /*#__PURE__*/_createElementVNode("td", null, "8.9")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", { class: "lalign" }, "arrested development quotes"),
      /*#__PURE__*/_createElementVNode("td", null, "13,500"),
      /*#__PURE__*/_createElementVNode("td", null, "900"),
      /*#__PURE__*/_createElementVNode("td", null, "6.7%"),
      /*#__PURE__*/_createElementVNode("td", null, "12.0")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", { class: "lalign" }, "popular web series"),
      /*#__PURE__*/_createElementVNode("td", null, "8,700"),
      /*#__PURE__*/_createElementVNode("td", null, "350"),
      /*#__PURE__*/_createElementVNode("td", null, "4%"),
      /*#__PURE__*/_createElementVNode("td", null, "7.0")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", { class: "lalign" }, "2013 webapps"),
      /*#__PURE__*/_createElementVNode("td", null, "9,900"),
      /*#__PURE__*/_createElementVNode("td", null, "460"),
      /*#__PURE__*/_createElementVNode("td", null, "4.6%"),
      /*#__PURE__*/_createElementVNode("td", null, "11.5")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", { class: "lalign" }, "ring bananaphone"),
      /*#__PURE__*/_createElementVNode("td", null, "10,500"),
      /*#__PURE__*/_createElementVNode("td", null, "748"),
      /*#__PURE__*/_createElementVNode("td", null, "7.1%"),
      /*#__PURE__*/_createElementVNode("td", null, "17.3")
    ])
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

// $(function(){
//   $('#keywords').tablesorter();
// });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}
}

})